import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

const useOnQueryResult = (queryKey, { onSuccess, onError } = {}) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      if (event?.type === 'updated') {
        // Check for success and call onSuccess if provided
        if (
          event.query.state.status === 'success' &&
          JSON.stringify(event.query.queryKey) === JSON.stringify(queryKey) &&
          typeof onSuccess === 'function'
        ) {
          onSuccess(event.query.state.data);
        }

        // Check for error and call onError if provided
        if (
          event.query.state.status === 'error' &&
          JSON.stringify(event.query.queryKey) === JSON.stringify(queryKey) &&
          typeof onError === 'function'
        ) {
          onError(event.query.state.error);
        }
      }
    });

    // Cleanup subscription on component unmount
    return () => unsubscribe();
  }, [queryClient, queryKey, onSuccess, onError]);
};

export default useOnQueryResult;
